import React from 'react';
import type { ViewMode } from '../../domain/types';
import { RadarView } from '../radar/RadarView';
import { JiraView } from '../jira/JiraView';
import { SlackView } from '../slack/SlackView';
import { GitHubView } from '../github/GitHubView';
import { GmailView } from '../gmail/GmailView';
import { AgentsView } from '../agents/AgentsView';
import { NotificationsView } from '../notifications/NotificationsView';
const WikiGraphView = React.lazy(() =>
  import('../wiki/WikiGraphView').then((module) => ({ default: module.WikiGraphView })),
);

type OpenTool = (tool: 'daily' | 'notes' | 'wiki', wikiPageId?: string) => void;

const VIEW_RENDERERS: Record<ViewMode, (onOpenTool: OpenTool) => React.ReactElement> = {
  radar: (onOpenTool) => <RadarView onOpenTool={onOpenTool} />,
  notifications: () => <NotificationsView />,
  jira: () => <JiraView />,
  slack: () => <SlackView />,
  github: () => <GitHubView />,
  gmail: () => <GmailView />,
  agents: () => <AgentsView />,
  wiki: (onOpenTool) => (
    <React.Suspense fallback={null}>
      <WikiGraphView onOpenEditor={(id) => onOpenTool('wiki', id)} />
    </React.Suspense>
  ),
};

export function renderActiveWorkspaceView(
  view: ViewMode,
  onOpenTool: OpenTool,
): React.ReactElement | null {
  const render = VIEW_RENDERERS[view];
  return render ? render(onOpenTool) : null;
}
